import { Button, ButtonColor } from '../../../../atoms/button';
import React, { useState } from 'react';
import { TermsAndConditionsModal } from '../modal-tsncs/terms-and-conditions';

export const Description = ({ description, id, tnc, handleClose }) => {
  const [showTncModal, setShowTncModal] = useState(false);

  const closeDescription = () => {
    handleClose();
  };

  const onClickTsAndCs = () => {
    setShowTncModal(true);
    setTimeout(() => {
      document
        .getElementById('modal-tsncs')
        .scrollIntoView({ block: 'center' });
      console.log(document.getElementById('modal-tsncs'));
    }, 1000);
  };

  return (
    <div className='tnc-stack description' data-testid={`${id}-description`}>
      <div dangerouslySetInnerHTML={{ __html: description }} />
      {typeof tnc === 'string' && (
        <div className='tnc-stack'>
          <a className='tnc' data-testid={`${id}-tnc`} onClick={onClickTsAndCs}>
            Terms and Conditions
          </a>
          <span> apply.</span>
        </div>
      )}
      {/*<div className='cta'>*/}
      {/*  <Button*/}
      {/*    color={ButtonColor.White}*/}
      {/*    onClick={closeDescription}*/}
      {/*    text='CLOSE'*/}
      {/*  />*/}
      {/*</div>*/}
      <TermsAndConditionsModal
        tnc={tnc}
        show={showTncModal}
        setShow={() => {
          setShowTncModal(!showTncModal);
        }}
      />
    </div>
  );
};
